// JsFromRoutes CacheKey bc9485d58830e91b65bb1bf9d0749e50
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/god-mode/enter'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/god-mode/exit'),
}
